const __request = require(`../default/__request`);
/**
 * 获取酒店日历金额
 */
export default function (val) {
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/hotel/manager/base/getHotelNightlyRates"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}
